
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M10.667 21.333L0 10.667h6.222V0h8.89v10.667h6.221z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M27-5v32H-5V-5z"}}),_c('g',{attrs:{"transform":"rotate(90 10.667 11)"}},[_c('mask',{attrs:{"id":"b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#a"}})]),_c('use',{attrs:{"fill":"#F5A623","xlink:href":"#a"}}),_c('g',{attrs:{"mask":"url(#b)","fill":"#4788C6","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M-5.333-5.333h32v32h-32z"}})])])])])
          )
        }
      }
    